import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext.tsx";

const Settings = () => {
  const { logout } = useAuth();
  const [activeSection, setActiveSection] = useState('');

  const menuItems = [
    { id: 'account', label: 'Account Management' },
    { id: 'profile', label: 'Profile Settings' },
    { id: 'notifications', label: 'Notifications' },
    { id: 'terms', label: 'Terms & Conditions' },
    { id: 'help', label: 'Help & Support' },
    { id: 'faq', label: 'FAQ' }
  ];


  const handleMenuClick = (itemId) => {
    setActiveSection(itemId);
    console.log(`Navigating to ${itemId}`);
  };

  return (
    <div className="h-[400px] bg-gray-100 flex flex-col mt-10">
      <div className="flex-1 max-w-4xl mx-auto w-full bg-white rounded-lg shadow-sm">
        <div className="p-6">
          <div className="space-y-1">
            {menuItems.map((item) => (
              <div
                key={item.id}
                onClick={() => handleMenuClick(item.id)}
                className={`
                  px-4 py-4 border-b border-gray-200 cursor-pointer
                  hover:bg-gray-50 transition-colors duration-150
                  ${activeSection === item.id ? 'bg-blue-50 border-l-4 border-l-blue-500' : ''}
                `}
              >
                <span className="text-gray-600 text-sm font-medium">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>


      <div className="max-w-4xl mx-auto w-full p-6">
        <button
          onClick={() => logout()}
          className="w-full bg-teal-700 hover:bg-teal-800 text-white font-medium py-4 px-6 rounded-lg transition-colors duration-200 shadow-sm"
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Settings;